import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: "ngx-dialog-report-spam",
  templateUrl: "dialog-report-spam.component.html",
  styleUrls: ["dialog-report-spam.component.scss"],
})
export class DialogReportSpamComponent implements OnInit {
  value?: number = 0;
  reason?: string;
  reasonElse?: string;

  diaForm: FormGroup;

  reasons = [
    {
      value: 0,
      reason: "Chọn lý do",
    },
    {
      value: 1,
      reason: "Tiếng Việt không dấu",
    },
    {
      value: 2,
      reason: "Nội dung vi phạm nội quy",
    },
    {
      value: 3,
      reason: "Phá hoại chủ đề",
    },
    {
      value: 4,
      reason:
        "Cố tình spam, làm loãng hoặc phá hỏng chủ đề của thành viên khác",
    },

    {
      value: 5,
      reason: "Từ ngữ không tinh tế hay thô tục",
    },

    {
      value: 6,
      reason: "Kích động, cố tình gây cãi nhau, xúc phạm nhau",
    },
    {
      value: 7,
      reason: "Vi phạm bản quyền",
    },
    {
      value: 8,
      reason: "Nôi dung liên quan hay bàn về chính trị",
    },
    {
      value: -1,
      reason: "Lý do khác",
    },
  ];

  submitted = false;

  constructor(
    protected ref: NbDialogRef<DialogReportSpamComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    const reasonValidators = [
      Validators.minLength(3),
      Validators.maxLength(250),
      Validators.required,
    ];

    this.diaForm = this.fb.group({
      reason: ["", reasonValidators],
      value: Validators.required,
    });
  }

  selectedReason(item) {
    this.value = item;
    this.reason = item != -1 ? this.reasons[item].reason : "";
    console.log("selected value:", this.value);
    console.log("selected reason:", this.reason);
    this.reasonElse = this.reason;
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.submitted = true;
    const value = {
      value: this.value,
      reason: this.reason,
    };
    this.ref.close(value);
  }
}
